import { CurrentPayoutAccountState } from 'modules/host-payout-methods/context/PayoutFormContext';
import {
  BankDetails,
  PayPal,
} from 'modules/host-payout-methods/models/PayoutFieldName';
import {
  BANK_TRANSFER,
  PAYPAL,
} from 'modules/host-payout-methods/models/PayoutMethods';

export default function (
  state: CurrentPayoutAccountState,
  action,
): CurrentPayoutAccountState {
  switch (action.type) {
    case 'SUBMIT':
      return {
        ...state,
        id: action.id || state.id,
      };
    case 'SUBMIT:SUCCESS':
      return {
        id: undefined,
        isPreferred: true,
        details: {
          billingCountry: undefined,
          type: undefined,
        },
        error: undefined,
      };
    case 'SUBMIT:ERROR':
      return {
        ...state,
        error: action.error,
      };
    case 'CLEAR_CURRENT_PAYOUT':
      return {
        id: undefined,
        isPreferred: true,
        details: {
          billingCountry: undefined,
          type: undefined,
        },
        error: undefined,
      };
    case 'TOGGLE_PREFERRED_PAYOUT_ACCOUNT':
      return {
        ...state,
        isPreferred: !state.isPreferred,
      };
    case 'FORM_INPUT_CHANGE':
      let newFields;
      switch (state.details.type) {
        case PAYPAL:
          newFields = {
            ...state.details,
            [action.event.target.name]: action.event.target.value,
          } as PayPal;
          break;
        case BANK_TRANSFER:
          newFields = {
            ...state.details,
            [action.event.target.name]: action.event.target.value,
          } as BankDetails;
          break;
      }
      return {
        ...state,
        details: {
          ...state.details,
          ...newFields,
        },
      };
    case 'SET_PAYOUT_ACCOUNT':
      return {
        ...state,
        ...action.payoutAccount,
      };
    case 'SET_BILLING_COUNTRY':
      return {
        ...state,
        details: {
          ...state.details,
          type: undefined,
          billingCountry: action.billingCountry,
        },
      };
    case 'SET_PAYOUT_METHOD':
      return {
        ...state,
        details: {
          ...state.details,
          type: action.payoutMethodId,
        },
      };
  }
  return state;
}
